import { ScrollBar } from "../../scroll-bar";
import { useHubTableContext } from "../hub-table.context";
import styles from "../hub-table.module.scss";
import type { HubTableScrollGutterProps } from "../types-hub-table";

/**
 * Barra de rolagem: o `ScrollBar` do DS ligado à área que rola; sem estouro ela não aparece. As duas ficam dentro da
 * moldura: a horizontal entre as colunas congeladas, a vertical ao lado do corpo. O polegar desconta o que fica parado.
 */
export function HubTableScrollGutter({ orientation }: HubTableScrollGutterProps) {
  const { scrollerRef, scrollAxes, partTestId } = useHubTableContext();

  return (
    <ScrollBar.Root
      scrollerRef={scrollerRef}
      orientation={orientation}
      inset={scrollAxes[orientation].inset}
      style={scrollAxes[orientation].style}
      className={styles.scrollBar}
      testId={partTestId(`scrollbar-${orientation}`)}
    />
  );
}
HubTableScrollGutter.displayName = "HubTable.ScrollGutter";
